<template>
	<div class="cart_content">
		<div class="cart_header flex align-center justify-between">
			<div class="name">All products</div>
			<!-- <div class="search">
				<input type="text" v-model="keyword">
				<img src="../../../assets/images/icon/select.png" alt="">
			</div> -->
		</div>
		<div class="main_content flex">
			<div class="menu">
				<div class="item" 
				v-for="(item,index) in menuList" :key="index"
				:class="index == menuActive ? 'active' : ''"
				@click="switchMenu(index)"
				>{{item}}</div>
			</div>
			<div class="cartList">
				<div class="cardType" v-if="menuActive == 0">
					<div class="header flex align-center">
						<div class="empty"></div>
						<div class="picture"></div>
						<div class="name leason">Class</div>
						<div class="date">Date</div>
						<div class="shop">Venue</div>
						<div class="time">Time</div>
						<div class="price">Amount</div>
						<div class="price">CP credit(s)</div>
						<div class="child">Child</div>
					</div>
					<div class="cart_list">
						<div class="item flex align-center" 
						:class="item.is_expired ? '' : 'main_item'"
						v-for="(item,index) in list" :key="index" 
						@click="selectCourse(index)">
							<div>
								<img v-if="item.select" class="empty" src="../../../assets/images/icon/select_active.png" alt="">
								<img v-else class="empty" src="../../../assets/images/icon/select.png" alt="">
							</div>
							
							<div class="picture">
								<img :src="imgBaseUrl + item.course.image" alt="">
							</div>
							<div class="name leason">
								<!-- <div>TARK flet</div>
								<div>那是一种内在的东西</div> -->
								<div>{{item.course.name}}</div>
							</div>
							<div class="date">{{item.course.start_date}}</div>
							<div class="shop">{{item.course.course_shop_name}}</div>
							<div class="time">{{item.course.start_time}}-{{item.course.end_time}}</div>
							<div class="price">£{{item.course.total_price}}</div>
							<div class="price">{{item.course.combo_num}}</div>
							<div class="child">
								<span v-for="(ite,ind) in item.child" :key="ind">{{ite.child_first_name}} {{ite.child_last_name}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="cardType" v-if="menuActive == 1">
					<div class="header flex align-center">
						<div class="empty"></div>
						<div class="picture"></div>
						<div class="name">Product name</div>
						<div class="price">Amount</div>
						<div class="num">Quantity</div>
					</div>
					<div class="cart_list">
						<div class="item flex align-center" v-for="(item,index) in list" :key="index">
							<img v-if="item.select" @click="switchSelct(index)" class="empty" src="../../../assets/images/icon/select_active.png" alt="">
							<img v-else class="empty" @click="switchSelct(index)" src="../../../assets/images/icon/select.png" alt="">
							<div class="picture">
								<img :src="imgBaseUrl + item.image" alt="">
							</div>
							<div class="name">
								<div>{{item.goods_name}}</div>
								<!-- <div>{{item.goods_name}}</div> -->
							</div>
							<div class="price">£{{item.goods_price}}</div>
							<div class="num flex align-center">
								<div class="del btn" @click="del(index)">-</div>
								<div class="number">{{item.num}}</div>
								<div class="add btn" @click="add(index)">+</div>
							</div>
						</div>
					</div>
				</div>
				<div class="cardType" v-if="menuActive == 2">
					<div class="header flex align-center">
						<div class="empty"></div>
						<div class="picture"></div>
						<div class="name leason">Class</div>
						<div class="date">Date</div>
						<div class="shop">Venue</div>
						<div class="time">Time</div>
						<div class="price">Amount</div>
						<div class="price">CP credit(s)</div>
						<div class="child">Child</div>
					</div>
					<div class="cart_list">
						<div class="item flex align-center" 
						:class="item.is_expired ? '' : 'main_item'"
						v-for="(item,index) in list" :key="index" 
						@click="selectCourse(index)">
							<div>
								<img v-if="item.select" class="empty" src="../../../assets/images/icon/select_active.png" alt="">
								<img v-else class="empty" src="../../../assets/images/icon/select.png" alt="">
							</div>
							
							<div class="picture">
								<img :src="imgBaseUrl + item.course.image" alt="">
							</div>
							<div class="name leason">
								<!-- <div>TARK flet</div>
								<div>那是一种内在的东西</div> -->
								<div>{{item.course.name}}</div>
							</div>
							<div class="date">{{item.course.start_date}}</div>
							<div class="shop">{{item.course.course_shop_name}}</div>
							<div class="time">{{item.course.start_time}}-{{item.course.end_time}}</div>
							<div class="price">£{{item.course.total_price}}</div>
							<div class="price">{{item.course.combo_num}}</div>
							<div class="child">
								<span v-for="(ite,ind) in item.child" :key="ind">{{ite.child_first_name}} {{ite.child_last_name}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="cardType" v-if="menuActive == 3">
					<div class="header flex align-center">
						<div class="empty"></div>
						<div class="picture"></div>
						<div class="name leason">Class</div>
						<div class="date">Date</div>
						<div class="shop">Venue</div>
						<div class="time">Time</div>
						<div class="price">Amount</div>
						<div class="price">CP credit(s)</div>
						<div class="child">Name</div>
					</div>
					<div class="cart_list">
						<div class="item flex align-center" 
						:class="item.is_expired ? '' : 'main_item'"
						v-for="(item,index) in list" :key="index" 
						@click="selectCourse(index)">
							<div>
								<img v-if="item.select" class="empty" src="../../../assets/images/icon/select_active.png" alt="">
								<img v-else class="empty" src="../../../assets/images/icon/select.png" alt="">
							</div>
							
							<div class="picture">
								<img :src="imgBaseUrl + item.course.image" alt="">
							</div>
							<div class="name leason">
								<!-- <div>TARK flet</div>
								<div>那是一种内在的东西</div> -->
								<div>{{item.course.name}}</div>
							</div>
							<div class="date">{{item.course.start_date}}</div>
							<div class="shop">{{item.course.course_shop_name}}</div>
							<div class="time">{{item.course.start_time}}-{{item.course.end_time}}</div>
							<div class="price">£{{item.course.total_price}}</div>
							<div class="price">{{item.course.combo_num}}</div>
							<div class="child">
								<span >{{item.full_name}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="pages">
					<el-pagination
					      @size-change="handleSizeChange"
					      @current-change="handleCurrentChange"
					      :current-page="currentPage"
					      :page-sizes="[100, 200, 300, 400]"
					      :page-size="pageSize"
					      layout="prev, pager, next,sizes, jumper"
						  :total="total"
					      >
					    </el-pagination>
				</div>
				<div class="remind_title" v-if="menuActive == 0">Class pack credits in your account:{{hasPack}} classes</div>
				<div class="remind_title" v-if="menuActive == 0">Credits used:{{combo_num}}</div>
				<div class="pay_bottom flex align-center justify-between">
					<div class="left flex align-center">
						<div class="select_all flex align-center" @click="selectAll">
							<img v-if="select" src="../../../assets/images/icon/select_active.png" alt="">
							<div class="select_box" v-else></div>
							<div>Select all</div>
						</div>
						<div class="del" v-if="menuActive == 0" @click="delCart">Delete classes</div>
						<div class="del" v-else @click="delCart">Delete products</div>
					</div>
					<div class="flex align-center" v-if="menuActive == 1">
						<div class="all_price">Total：<span>£{{totalPrice}}</span></div>
						<div class="pay_btn" @click="pay">Proceed to checkout</div>
					</div>
					<div class="flex align-center" v-else>
						<div class="all_price">Total：<span>£{{totalPrice}}</span></div>
						<div class="pay_btn" @click="showModel = true">Proceed to checkout</div>
					</div>
				</div>
			</div>
		</div>
		<div class="model" v-if="showModel">
			<div class="model_content">
				<div class="leason_header">
					<div class="title">Buy now</div>
					<img @click="showModel = false" src="../../../assets/images/icon/close.png" alt="">
				</div>
				<!-- <div class="addChild">
					<div class="title">添加孩子</div>
					<div class="list flex align-center">
						<div class="item flex align-center justify-between" v-for="(item,index) in selectChildList" :key="index">
							<div class="name">{{item.child_last_name}}</div>
							<img src="../../../assets/images/icon/del.png" alt="">
						</div>
						<div class="add flex align-center" @click="showChildList = true">
							<img src="../../../assets/images/icon/add.png" alt="">
							<div class="name">选择孩子</div>
							<div class="childList" v-if="showChildList">
								<div class="child_item" 
								@click.stop="select_child(index)"
								:class="selectChild == index ? 'active' : ''"
								v-for="(item,index) in childList" :key="index"
								>{{item.child_last_name}}</div>
							</div>
						</div>
					</div>
				</div> -->
				<div class="second">Class pack credits in your account:{{hasPack}} classes</div>
				<div class="discount_item flex align-center justify-between">
					<div class="name">Credits used</div>
					<div class="val">{{combo_num}}</div>
					<!-- <input type="text" class="val" v-model="" placeholder="Class Pack Credits" @blur="ensureOrder"> -->
				</div>
				<div class="discount_item flex align-center justify-between">
					<div class="name">Discount Code</div>
					<input type="text" class="val" v-model="discount_code" placeholder="Discount Code" @blur="ensureOrder">
				</div>
				<div class="price_bottom flex align-center justify-between">
					<div class="price">Total Balance:<span>£{{totalPrice}}</span></div>
					<div class="btn_list">
						<div class="btn" @click="cartSubmitOrder">Buy now</div>
					</div>
					
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				menuList:['Classes Basket','Products Basket','Events & Camps','Parents Basket'],
				menuActive:0,
				keyword:'',
				total:0,
				currentPage:1,
				pageSize:10,
				select:false,
				list:[],
				totalPrice:0,
				// 课程购物车
				showModel:false,
				showChildList:false,
				selectChild:0,
				selectChildList:[],
				childList:[],
				combo_num:0,
				discount_code:'',
				courseList:[],
				hasPack:0,
				
			}
		},
		created(){
			this.menuActive = this.$route.query.type;
			if(this.menuActive == 1){
				this.getGoodsList()
			}else if (this.menuActive == 0){
				this.getCourseList();
				this.getChild();
				this.getpack()
			}else{
				this.getEventList();
				this.getChild();
				this.getpack()
			}
		},
		methods:{
			switchMenu(index){
				this.menuActive = index;
				this.currentPage = 1;
				this.total = 0;
				this.sele = false;
				if(index == 1){
					this.getGoodsList()
				}else if(index == 0){
					this.getCourseList();
				}else if(index == 2){
					this.getEventList();
				}else{
					this.getParentsList()
				}
			},
			// 获取套餐余量
			getpack(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.hasPack = res.data.combo_num;
					}
				})
			},
			// 获取孩子列表
			getChild(){
				this.$api.post('user/getChildList',{},res=>{
					if(res.code == 1){
						this.childList = res.data;
					}
				})
			},
			selectCourse(index){
				if(this.menuActive == 2){
					if(this.list[index].course.is_combo == 1){
						if(this.hasPack <= 0){
							this.$message({
								showClose:true,
								duration:0,
								message:'This course can only be purchased by package members'
							})
							return
						}
					}
				}
				this.list[index].select = !this.list[index].select;
				var status = false;
				this.select = true;
				this.combo_num = 0;
				var has_buy = false;
				
				this.list.forEach((item,index)=>{
					if(!item.select){
						status = true;
						
					}else{
						this.combo_num = this.combo_num + item.num*item.course.combo_num
					}
				})
				if(status){
					this.select = false;
				}
				this.ensureOrder()
			},
			
			// 选择单个商品
			switchSelct(index){
				this.list[index].select = !this.list[index].select;
				this.countPrice();
				var status = false;
				this.select = true;
				this.list.forEach((item,index)=>{
					if(!item.select){
						status = true;
					}
				})
				if(status){
					this.select = false;
				}
				this.countPrice()
			},
			// 全选
			selectAll(){
				this.select = !this.select;
				this.combo_num = 0;
				if(this.select){
					this.list.forEach((item,index)=>{
						item.select = true
						if(this.menuActive == 0){
							this.combo_num = this.combo_num+item.num*item.course.combo_num
						}
					})
				}else{
					this.list.forEach((item,index)=>{
						item.select = false
					})
				}
				if(this.menuActive == 0 || this.menuActive == 2 || this.menuActive == 3){
					this.ensureOrder()
				}else{
					this.countPrice()
				}
				
			},
			// 计算应付价格
			countPrice(){
				var price = 0;
				this.list.forEach((item,index)=>{
					if(item.select){
						price += item.goods_price*item.num
					}
				})
				this.totalPrice = price;
			},
			pay(){
				var cart_id = [];
				this.list.forEach((item,index)=>{
					if(item.select){
						cart_id.push(item.id)
					}
				})
				cart_id = cart_id.join(',')
				this.$router.push({ path: '/home/pay', query: {cart_id: cart_id,type:1}})
			},
			// 删除购物车
			delCart(){
				var arr = [];
				this.list.forEach((item,index)=>{
					if(item.select){
						arr.push(item.id)
					}
				})
				var params = {
					cart_id:arr.join(',')
				}
				console.log(params)
				if(this.menuActive == 0){
					this.$api.post('course_cart/del',params,res=>{
						if(res.code == 1){
							this.$message({
								showClose:true,
								duration:0,
								message:'succesfully deleted'
							})
							this.getCourseList()
						}else{
							this.$message({
								showClose:true,
								duration:0,
								message:res.msg
							})
						}
					})
				}else if(this.menuActive == 1){
					this.$api.post('cart/del',params,res=>{
						if(res.code == 1){
							this.$message({
								showClose:true,
								duration:0,
								message:'succesfully deleted'
							})
							this.getGoodsList()
						}else{
							this.$message({
								showClose:true,
								duration:0,
								message:res.msg
							})
						}
					})
				}else if(this.menuActive == 2){
					this.$api.post('Events_cart/del',params,res=>{
						if(res.code == 1){
							this.$message({
								showClose:true,
								duration:0,
								message:'succesfully deleted'
							})
							this.getEventList()
						}else{
							this.$message({
								showClose:true,
								duration:0,
								message:res.msg
							})
						}
					})
				}else{
					this.$api.post('parents_cart/del',params,res=>{
						if(res.code == 1){
							this.$message({
								showClose:true,
								duration:0,
								message:'succesfully deleted'
							})
							this.getParentsList()
						}else{
							this.$message({
								showClose:true,
								duration:0,
								message:res.msg
							})
						}
					})
				}
				
			},
			
			// 添加购物车数量
			add(index){
				this.$api.post('cart/inc',{cart_id:this.list[index].id},res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Successful'
						})
						if(this.menuActive == 1){
							this.getGoodsList()
						}
						
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			// 减少数量
			del(index){
				this.$api.post('cart/dec',{cart_id:this.list[index].id},res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Successful'
						})
						
						if(this.menuActive == 1){
							this.getGoodsList()
						}
						
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			// 确认订单信息
			ensureOrder(){
				var card_id = []
				this.list.forEach((item,index)=>{
					if(item.select){
						card_id.push(item.id)
					}
				})
				if(this.hasPack>0){
					if(this.hasPack < this.combo_num){
						this.combo_num = this.hasPack;
					}
				}else{
					this.combo_num = 0;
				}
				var params = {
					cart_id:card_id.join(','),
					combo_num:this.combo_num,
					discount_code:this.discount_code,
				}
				if(this.menuActive == 0){
					this.$api.post('course_cart/getCartList',params,res=>{
						if(res.code == 1){
							
							this.totalPrice = res.data.total_price
						}
					})
				}else if(this.menuActive == 2){
					this.$api.post('Events_cart/getCartList',params,res=>{
						if(res.code == 1){
							
							this.totalPrice = res.data.total_price
						}
					})
				}else{
					this.$api.post('parents_cart/getCartList',params,res=>{
						if(res.code == 1){
							
							this.totalPrice = res.data.total_price
						}
					})
				}
				
			},
			// 创建课程购物车订单
			cartSubmitOrder(){
				var card_id = []
				this.list.forEach((item,index)=>{
					if(item.select){
						card_id.push(item.id)
					}
				})
				var params = {
					cart_id:card_id.join(','),
					combo_num:this.combo_num,
					discount_code:this.discount_code,
				}
				if(this.menuActive == 0){
					this.$api.post('course_order/cartSubmitOrder',params,res=>{
						if(res.code == 1){
							if(this.totalPrice > 0){
								this.coursePay(res.data.order_sn)
							}else{
								this.$message({
									showClose:true,
									duration:0,
									message:'Successful'
								})
								this.$router.push({path:'/home/userInfo/PaySuccess',query:{type:1}})
								// this.$router.push('/home/userInfo/PaySuccess')
							}
							
						}else{
							this.$message({
								showClose:true,
								duration:0,
								message:res.msg
							})
						}
					})
				}else if(this.menuActive == 2){
					this.$api.post('Events_order/cartSubmitOrder',params,res=>{
						if(res.code == 1){
							if(this.totalPrice > 0){
								this.coursePay(res.data.order_sn)
							}else{
								this.$message({
									showClose:true,
									duration:0,
									message:'Successful'
								})
								this.$router.push({path:'/home/userInfo/PaySuccess',query:{type:1}})
								// this.$router.push('/home/userInfo/PaySuccess')
							}
							
						}else{
							this.$message({
								showClose:true,
								duration:0,
								message:res.msg
							})
						}
					})
				}else{
					this.$api.post('parents_order/cartSubmitOrder',params,res=>{
						if(res.code == 1){
							if(this.totalPrice > 0){
								this.coursePay(res.data.order_sn)
							}else{
								this.$message({
									showClose:true,
									duration:0,
									message:'Successful'
								})
								this.$router.push({path:'/home/userInfo/PaySuccess',query:{type:1}})
								// this.$router.push('/home/userInfo/PaySuccess')
							}
							
						}else{
							this.$message({
								showClose:true,
								duration:0,
								message:res.msg
							})
						}
					})
				}
				
			},
			coursePay(order_sn){
				this.$api.post('pay/stripe',{order_sn:order_sn,type:'pc'},res=>{
					if(res.code == 1){
						location.href=res.data.url
					}
				})
			},
			// 获取课程购物车列表
			getCourseList(){
				this.$api.post('course_cart/getCartList',{page:this.currentPage},res=>{
					if(res.code == 1){
						res.data.all_course_list.data.forEach((item,index)=>{
							item.select = false;
							item.course.end_time = item.course.end_time.substring(0,5);
							item.course.start_time = item.course.start_time.substring(0,5);
							item.course.total_price = item.course.price * item.child.length;
						})
						this.list = res.data.all_course_list.data;
						this.total = res.data.all_course_list.total;
						this.pageSize = res.data.all_course_list.per_page;
						this.totalPrice = res.data.total_price
					}
				})
			}, 
			// 获取event购物车列表
			getEventList(){
				this.$api.post('Events_cart/getCartList',{page:this.currentPage},res=>{
					if(res.code == 1){
						res.data.all_course_list.data.forEach((item,index)=>{
							item.select = false;
							item.course.end_time = item.course.end_time.substring(0,5);
							item.course.start_time = item.course.start_time.substring(0,5);
							item.course.total_price = item.course.price * item.child.length;
						})
						this.list = res.data.all_course_list.data;
						this.total = res.data.all_course_list.total;
						this.pageSize = res.data.all_course_list.per_page;
						this.totalPrice = res.data.total_price
					}
				})
			},
			// 获取parents列表
			getParentsList(){
				this.$api.post('parents_cart/getCartList',{page:this.currentPage},res=>{
					if(res.code == 1){
						res.data.all_course_list.data.forEach((item,index)=>{
							item.select = false;
							item.course.end_time = item.course.end_time.substring(0,5);
							item.course.start_time = item.course.start_time.substring(0,5);
							item.course.total_price = item.course.price ;
						})
						
						this.list = res.data.all_course_list.data;
						console.log(this.list)
						this.total = res.data.all_course_list.total;
						this.pageSize = res.data.all_course_list.per_page;
						this.totalPrice = res.data.total_price
					}
				})
			},
			// 获取商品购物车列表
			getGoodsList(){
				var params = {
					page:this.currentPage
				}
				this.$api.post('cart/getCartGoodsList',params,res=>{
					if(res.code == 1){
						this.total = res.data.total;
						this.pageSize = res.data.per_page
						res.data.data.forEach((item,index)=>{
							item.select = false;
						})
						this.list = res.data.data;
						// if(this.currentPage == 1){
							
						// }else{
						// 	this.list = this.list.concat(res.data.data)
						// }
					}
				})
			},
			 handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			  },
			  handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				console.log(val,this.currentPage)
				this.currentPage = val;
				if(this.menuActive = 0){
					this.getGoodsList()
				}else{
					this.getCourseList()
				}
			  }
		}
	}
</script>

<style lang="scss" scoped>
	.cart_content{
		width: 1200px;
		margin: 0 auto;
	}
	.cart_header{
		width: 100%;
		height: 110px;
		.name{
			font-size: 22px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
		}
		.search{
			width: 386px;
			height: 50px;
			background: #F7F2EB;
			border: 1px solid #5C707A;
			border-radius: 25px;
			position: relative;
			input{
				width: 100%;
				height: 50px;
				line-height: 50px;
				padding: 0 73px 0 20px;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 200;
				color: #5C707A;
			}
			img{
				width: 33px;
				height: 33px;
				position: absolute;
				right: 20px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		
	}
	.main_content{
		width: 100%;
		margin-top: 30px;
		.menu{
			width: 200px;
			flex-shrink: 0;
			padding-top: 35px;
			.item{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				margin-bottom: 65px;
				cursor: pointer;
			}
			.active{
				color: #5C707A;
			}
		}
		.cartList{
			width: calc(100% - 200px);
			.header{
				width: 100%;
				height: 88px;
				background: #F0E3D0;
				border-radius: 10px;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				.empty{
					width: 21px;
					margin-right: 20px;
				}
				.picture{
					width: 119px;
				}
				.name{
					width: 205px;
					padding-left: 30px;
					&.leason{
						width: 246px;
					}
				}
				.date{
					width: 120px;
					// text-align: center;
				}
				.time{
					width: 100px;
				}
				.shop{
					width: 120px;
				}
				.price{
					width: 100px;
				}
				.num{
					width: 180px;
				}
			}
			.cart_list{
				width: 100%;
				padding-top: 60px;
				.item{
					padding: 30px 0;
					border-bottom: 1px solid #5C707A;
					&.main_item{
						background: #EDE8E1;
					}
					
				}
				.empty{
					width: 21px;
					height: 21px;
					margin-right: 20px;
				}
				.picture{
					width: 119px;
					height: 119px;
					border-radius: 10px;
					overflow: hidden;
					flex-shrink:0;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.name{
					width: 205px;
					padding-left: 30px;
					font-size: 16px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 24px;
					&.leason{
						width: 246px;
					}
				}
				.shop{
					width: 120px;
				}
				.price{
					width: 100px;
					font-size: 16px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #BF5F49;
					text-align:center;
				}
				.date{
					width: 120px;
					font-size: 16px;
					font-family: PingFang SC;
					font-weight: bold;
					color: #282E30;
					// text-align: center;
				}
				.time{
					width: 100px;
					font-size: 16px;
					font-family: PingFang SC;
					font-weight: bold;
					color: #282E30;
					
				}
				.num{
					width: 108px;
					height: 42px;
					border: 1px solid #888888;
					border-radius: 10px;
					line-height: 42px;
					font-size: 16px;
					font-family: PingFang SC;
					font-weight: 400;
					color: #020201;
					.btn{
						flex-grow: 1;
						text-align: center;
						cursor: pointer;
					}
					.number{
						width: 64px;
						flex-shrink: 0;
						text-align: center;
						border-right: 1px solid #959595;
						border-left:1px solid #959595;
					}
				}
			}
		}
		.remind_title{
			text-align: right;
			margin-top: 10px;
			font-size: 20px;
		}
		.pay_bottom{
			margin-top: 20px;
			width: 100%;
			.select_all{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				cursor: pointer;
				img{
					width: 21px;
					height: 21px;
					margin-right: 10px;
					
				}
				.select_box{
					width: 21px;
					height: 21px;
					border: 1px solid #282E30;
					border-radius: 50%;
					margin-right: 10px;
				}
			}
			.del{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				margin-left: 60px;
				cursor: pointer;
			}
			.all_price{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				span{
					color: #BF5F49;
				}
			}
			.pay_btn{
				height: 58px;
				background: #5C707A;
				border-radius: 29px;
				text-align: center;
				line-height: 58px;
				margin-left: 75px;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				cursor: pointer;
				padding: 0 20px;
			}
		}
		.pages{
			width: 100%;
			display: flex;
			justify-content: flex-end;
			padding-top: 40px;
			::v-deep .btn-prev{
				width: 30px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;	
				padding: 0;
			}
			::v-deep .el-icon{
				font-size: 12px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C1C1C1;
				text-align: center;
			}
			::v-deep .el-pager .number{
				width: 30px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;
				margin-left: 7px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5E5E5E;
				text-align: center;
				line-height: 30px;
				padding: 0;
			}
			::v-deep .el-pager .number.active{
				background: #5C707A;
				color: #FFFFFF;
			}
			::v-deep .btn-next{
				width: 30px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;	
				padding: 0;
				margin-left: 8px;
			}
			::v-deep .el-select{
				width: 90px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;
				margin-left: 15px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5E5E5E;
			}
			::v-deep .el-pagination .el-select .el-input{
				width: 100%;
				height: 100%;
				margin: 0;
			}
			::v-deep .el-pagination .el-select .el-input .el-input__inner{
				padding: 0 6px;
				border: none;
				background-color: #F7F2EB;
				height: 26px;
			}
			::v-deep .el-pagination__editor.el-input{
				width: 40px;
				height: 30px;
				background: #F7F2EB;
				border: 1px solid #C1C1C1;
				border-radius: 7px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5E5E5E;
				text-align: center;
				line-height: 30px;
				padding:0;
				
			}
			::v-deep .el-pagination__editor.el-input .el-input__inner{
				padding:0;
				background-color: #F7F2EB;
				border: none;
				height: 18px;
			}
		}
	}
	.model{
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0,0,0,0.3);
		z-index: 99;
		.model_content{
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			width: 748px;
			height: 80%;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			padding: 0 30px 70px;
			overflow-y: scroll;
			.leason_header{
				width: 100%;
				height: 88px;
				border-bottom: 1px solid #5C707A;
				position: relative;
				.title{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #282E30;
					line-height: 88px;
				}
				img{
					width: 29px;
					height: 28px;
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			.second{
				font-size: 22px;
				font-family: Adobe Heiti Std;
				font-weight: normal;
				color: #BF5F49;
				text-align: center;
				margin-top: 20px;
			}
			.addChild{
				padding-top: 20px;
				padding-bottom: 40px;
				border-bottom: 1px solid #5C707A;
			
				.title{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #000000;
					margin-bottom: 16px;
				}
				.list{
					flex-wrap: wrap;
					.item{
						width: 174px;
						height: 60px;
						background: #F7F2EB;
						border: 1px solid #5C707A;
						border-radius: 10px;
						padding: 0 10px;
						margin-right: 20px;
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						line-height: 60px;
						img{
							width: 26px;
							height: 26px;
						}
					}
					.add{
						margin-left: 40px;
						font-size: 22px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						position: relative;
						cursor: pointer;
						img{
							width: 26px;
							height: 26px;
							margin-right: 10px;
						}
					}
					.childList{
						width: 100%;
						height: 100px;
						position: absolute;
						left: 0;
						top: 50px;
						border: 1px solid #ccc;
						border-radius: 10px;
						padding: 10px;
						background-color: #fff;
						overflow-y: scroll;
						.child_item{
							cursor: pointer;
							&.active{
								color: #C98B2C;
							}
						}
					}
				}
			}
			.discount_item{
				width: 100%;
				height: 62px;
				border-bottom: 1px solid #5C707A;
				padding: 0 30px 0 15px;
				.name{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
				}
				.val{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #BF5F49;
					text-align: right;
				}
			}
			.price_bottom{
				margin-top: 30px;
				.price{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					span{
						color: #BF5F49;
					}
				}
				.btn{
					width: 182px;
					height: 58px;
					background: #5C707A;
					border-radius: 29px;
					line-height: 58px;
					text-align: center;
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #F7F2EB;
					margin-left: 10px;
					cursor: pointer;
				}
			}
		}
	}
	
</style>